<div class="payments-page">
  <rms-tab-group (tabSelected)="onTabSelected($event)">

    <!-- ======================= ORDER PAYMENT STATUS (legacy screen) ======================= -->
    <rms-tab label="Order Payment Status" [active]="true">
      <ng-template>

        <!-- Top bar: stat cards (click to filter) + filters -->
        <div class="top-bar-row">
          <div class="stat-cards">
            @for (card of StatCards; track card.key) {
            <div class="summary-card {{ card.cssClass }}"
                 [class.active]="ActiveCard === card.key"
                 (click)="selectCard(card)">
              <div class="summary-label">{{ card.label }}</div>
              <div class="summary-value">{{ cardValue(card) }}</div>
              @if (cardSub(card) !== null) {
              <div class="summary-sub">{{ cardSub(card) | currency: 'USD' : 'symbol' : '1.2-2' }}</div>
              }
            </div>
            }
          </div>

          <div class="filter-row">
            <label class="toggle">
              <input type="checkbox" [checked]="UnpaidOnly" [disabled]="Loading" (change)="toggleUnpaidOnly()" />
              Show unpaid only
            </label>
            <label class="months">
              Sold in the last
              <select [ngModel]="MonthsBack" (ngModelChange)="changeMonths($event)" [disabled]="Loading">
                @for (m of MonthsOptions; track m) {
                <option [ngValue]="m">{{ m }} months</option>
                }
              </select>
            </label>
          </div>
        </div>

        @if (!LoadedAll) {
        <div class="note">
          Showing the newest {{ AllRows.length }} of {{ Totals?.TotalRows }} orders — narrow the period to see the rest.
        </div>
        }

        <!-- rms-table needs columns ready before it renders -->
        @if (Loaded) {
        <div class="table-wrap" [class.busy]="Busy || Loading">
          <rms-table [HeaderButtons]="Buttons"
                     [parentContext]="this"
                     [data]="FilteredRows"
                     [columns]="Columns"
                     [getIcons]="getRowIcons"
                     ActionsText="Partial"
                     [pageSize]="100"
                     tableId="customer-payments-order-status"
                     [customizable]="true"
                     startSort="OrderID"
                     startSortDirection="desc">
          </rms-table>
        </div>
        } @else {
        <div class="loading">Loading…</div>
        }

      </ng-template>
    </rms-tab>

    <!-- ======================= RECEIPTS ======================= -->
    <rms-tab label="Receipts">
      <ng-template>
        @if (Loaded) {
        <app-receipt-queue mode="RECEIPTS" [options]="Options" (changed)="loadQueueSummary()"></app-receipt-queue>
        } @else {
        <div class="loading">Loading…</div>
        }
      </ng-template>
    </rms-tab>

    <!-- ======================= EXCEPTIONS ======================= -->
    <rms-tab [label]="ExceptionsTabLabel">
      <ng-template>
        @if (Loaded) {
        <app-receipt-queue mode="EXCEPTIONS" [options]="Options" (changed)="loadQueueSummary()"></app-receipt-queue>
        } @else {
        <div class="loading">Loading…</div>
        }
      </ng-template>
    </rms-tab>

    <!-- ======================= NEEDS RECEIPT ======================= -->
    <rms-tab [label]="NeedsReceiptTabLabel">
      <ng-template>
        @if (Loaded) {
        <app-needs-receipt [options]="Options" (changed)="loadQueueSummary()"></app-needs-receipt>
        } @else {
        <div class="loading">Loading…</div>
        }
      </ng-template>
    </rms-tab>

  </rms-tab-group>
</div>
